import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetUsersQuery } from './usersApiSlice'
import { memo } from 'react'
import getFilePath from '../../utils/getFilePath'
const User = ({ userId, inx }) => {
    const {groupId, type} = useParams()
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })

    const navigate = useNavigate()

    if (user) {
        const handleEdit = () => navigate(`/${type}/${groupId}/users/${userId}`)

        const userRolesString = user.roles.toString().replaceAll(',', ', ')
        const userGroupsString = user.groups.toString().replaceAll(',', ', ')

        const cellStatus = user.active ? '' : 'table__cell--inactive'

        return (
            <tr className="table__row user">
                <td className={`table__cell ${cellStatus}`}>
                    {user.username}
                   
                   </td>
                <td className={`table__cell ${cellStatus}`}>
                    <span className="d-flex">
                     {inx + 1}. {user.name}
                    {user.image && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(user.image)})`}}></div>}
                    </span>
                    
                    </td>  
                <td className={`table__cell user__email ${cellStatus}`}>{user.email}</td> 
                <td className={`table__cell user__phone ${cellStatus}`}>{user.phone}</td> 
                {/* <td className={`table__cell ${cellStatus}`}>{userGroupsString}</td>                                        */}
                <td className={`table__cell ${cellStatus}`}>{userRolesString}</td>
                <td className={`table__cell ${cellStatus}`}>
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        )

    } else return null
}

const memoizedUser = memo(User)

export default memoizedUser